module.exports = __webpack_public_path__ + "img/music_016.7f21896d.png";